// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAnalyticsForAdminRequestModel from '../../model/get-analytics-for-admin-request-model';
import GetAnalyticsForAdminRequestDTO from '../dto/get-analytics-for-admin-request-dto';
import dtoSchema from '../schemas/get-analytics-for-admin-request-schema';

export default abstract class GetAnalyticsForAdminRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAnalyticsForAdminRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.selectedOrganisationId = data.selectedOrganisationId;
      this.selectedCompanyId = data.selectedCompanyId;
      this.eventIdentifier = data.eventIdentifier;
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  selectedOrganisationId?: number;
  /**
  * @type {int64}
  */
  selectedCompanyId?: number;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetAnalyticsForAdminRequestDTO>): GetAnalyticsForAdminRequestModel;
  static toModel(dto: DeepPartial<GetAnalyticsForAdminRequestDTO> | undefined | null): GetAnalyticsForAdminRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAnalyticsForAdminRequestDTO> | undefined | null): GetAnalyticsForAdminRequestModel | undefined {
    return dto ? new GetAnalyticsForAdminRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAnalyticsForAdminRequestModel> | GetAnalyticsForAdminRequestModel): GetAnalyticsForAdminRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      selectedOrganisationId: unwrapped.selectedOrganisationId,
      selectedCompanyId: unwrapped.selectedCompanyId,
      eventIdentifier: unwrapped.eventIdentifier,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as GetAnalyticsForAdminRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAnalyticsForAdminRequestModel, can not map to GetAnalyticsForAdminRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
